<template>
  <div class="sprouter-detail">
    <div class="photo">
      <img :src="photo" :class="{ 'img-fix': isPhotoPosFix }" />
    </div>
    <div class="content">
      <div class="name-container">
        <div class="name">{{ name }}</div>
        <div class="position">{{ position }}</div>
      </div>
      <div v-html="article" class="article"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SprouterDetail",
  props: ["photo", "name", "position", "article", "activeGeneration"],
  computed: {
    // 從 2019 年開始的圖片素材置中需要另外處理，請視圖片素材決定是否執行此函式
    isPhotoPosFix() {
      return (
        this.activeGeneration == "2019" ||
        this.activeGeneration == "2020" ||
        this.activeGeneration == "2021" ||
        this.activeGeneration == "2022"
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../static/styles/palette.scss";

.sprouter-detail {
  width: 960px;
  height: 300px;
  display: flex;
  justify-content: space-between;

  & .photo {
    position: relative;
    width: 48%;
    height: 100%;
    background-color: $lightGray;
    border: none;
    overflow: hidden;
    text-align: center;

    & img {
      position: relative;
      height: 110%;
    }

    & .img-fix {
      width: 100%;
      height: 100%;
      top: 0;
    }
  }

  & .content {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    width: 48%;
    height: 100%;
    color: white;

    & .name-container {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      width: 100%;
      font-family: "Fugaz One";

      & .name {
        position: relative;
        font-size: 38px;
        letter-spacing: 3px;
        top: 8px;
      }

      & .position {
        bottom: 3px;
        font-size: 16px;
        letter-spacing: 1px;
        max-width: 255px;
        text-align: end;
        align-self: flex-end;
      }
    }

    & .article {
      position: relative;
      height: 210px;
      width: 100%;
      border: 4px solid;
      border-color: white;
      padding: 0 20px;
      letter-spacing: 1.3px;
      overflow-y: auto;
      line-height: 24px;
    }

    & .article::-webkit-scrollbar {
      width: 10px;
      height: 8px;
      background-color: $darkGray;
    }
    & .article::-webkit-scrollbar-thumb {
      background: $lightGray;
    }
  }
}

@media all and (max-width: 1200px) {
  .sprouter-detail {
    width: 80%;
    height: 350px;

    & .photo {
      display: none;
    }

    & .content {
      width: 100%;

      & .article {
        height: 250px;
      }
    }
  }
}

@media all and (max-width: 320px) {
  .sprouter-detail {
    width: calc(100% - 40px);
  }
}
</style>



// WEBPACK FOOTER //
// SprouterDetail.vue?4f940aa6